/**
 * Listens to +postMessage+ calls, and if the data has a +channel+ property,
 * ferries the message to an in-memory publish-subscribe event channel.
 * Currently, it's only in use for reauth events, as reauthentication is done in an iframe.
 *
 * You can listen to any channel via this code:
 *
 * ```
 * import pmHub from '@mc/post-message-hub';
 * pmHub.subscribe(channel, (payload) => { /* do stuff here *\/ });
 * ```
 */

const channels = {};

const pmHub = {
  subscribe: (channel: $TSFixMe, listener: $TSFixMe) => {
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    const listeners = channels[channel] || [];
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    channels[channel] = [...listeners, listener];
    return pmHub.unsubscribe.bind(pmHub, channel, listener);
  },
  publish: (channel: $TSFixMe, payload?: $TSFixMe, source?: $TSFixMe) => {
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    const listeners = channels[channel] || [];
    listeners.forEach((listener: $TSFixMe) => listener(payload, source));
  },
  unsubscribe: (channel: $TSFixMe, listenerToRemove: $TSFixMe) => {
    if (channel in channels) {
      // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      channels[channel] = channels[channel].filter((listener: $TSFixMe) => {
        return listener !== listenerToRemove;
      });
    }
  },
};

// eslint-disable-next-line local-rules/remove-applied-listeners
window.addEventListener('message', (event) => {
  const domain = document.location.protocol + '//' + document.location.host;
  if (event.origin !== domain) {
    return;
  }
  if (!event.data || !event.data.channel) {
    return;
  }
  const { channel, payload } = event.data;
  pmHub.publish(channel, payload, event.source);
});

export default pmHub;
